package com.crowpay.views.screens.auth

import com.crowpay.AccountInfo
import com.crowpay.Address
import com.crowpay.Contractor
import com.crowpay.ContractorStatus
import com.crowpay.LicenseType
import com.crowpay.PaymentSetupRequest
import com.crowpay.SharedUtils
import com.crowpay.State
import com.crowpay.views.components.nav.AppDimensions
import com.crowpay.address
import com.crowpay.annualRevenue
import com.crowpay.averageJobSize
import com.crowpay.contactAddress
import com.crowpay.contactEmail
import com.crowpay.contactFirstName
import com.crowpay.contactLastName
import com.crowpay.contactPhoneNumber
import com.crowpay.contractor
import com.crowpay.edit
import com.crowpay.ein
import com.crowpay.email
import com.crowpay.employeeCount
import com.crowpay.extensions.isNotBlank
import com.crowpay.extensions.isValid
import com.crowpay.fileType
import com.crowpay.notNullContractor
import com.crowpay.legalName
import com.crowpay.name
import com.crowpay.operationStates
import com.crowpay.otherBusinessData
import com.crowpay.owners
import com.crowpay.phoneNumber
import com.crowpay.sdk.currentSession
import com.crowpay.sdk.notNullSession
import com.crowpay.selectedContractor
import com.crowpay.stateEntityNumber
import com.crowpay.trash
import com.crowpay.utils.existsDefaultFalse
import com.crowpay.utils.navigateTo
import com.crowpay.utils.nullableToBlank
import com.crowpay.utils.pushChanges
import com.crowpay.utils.resize
import com.crowpay.utils.validation.ValidCondition
import com.crowpay.utils.validation.ValidatedWritable
import com.crowpay.utils.validation.Validator
import com.crowpay.utils.validation.validate
import com.crowpay.utils.validation.validating
import com.crowpay.utils.withReverseIndex
import com.crowpay.utils.zeroToNull
import com.crowpay.views.components.EditSpecifications
import com.crowpay.views.components.Indent
import com.crowpay.views.components.addressForm
import com.crowpay.views.components.field3
import com.crowpay.views.components.files.FilePreview
import com.crowpay.views.components.files.renderContractorDocuments
import com.crowpay.views.components.files.renderLicenses
import com.crowpay.views.components.indentIfWideCol
import com.crowpay.views.components.label2
import com.crowpay.views.components.leftExpandButton
import com.crowpay.views.components.multiselect
import com.crowpay.views.components.requiredField
import com.crowpay.views.components.requiredField3
import com.crowpay.views.components.requiredLabel2
import com.crowpay.views.dialogs.CreateOrEditOwner
import com.crowpay.views.dialogs.GenericConfirmationDialog
import com.crowpay.views.screens.common.NotificationSubscriptionSettings
import com.crowpay.views.screens.common.ProjectLens
import com.crowpay.views.screens.common.ProjectView.RegisterAccountSection
import com.crowpay.views.screens.contractor.ContractorDashboard
import com.crowpay.views.screens.contractor.ManageContractorUsers
import com.crowpay.views.theming.AppColors
import com.crowpay.views.theming.BackgroundSemantic
import com.crowpay.views.theming.DangerButtonSemantic
import com.crowpay.views.theming.ForegroundSemantic
import com.crowpay.views.theming.MaxRadiiSemantic
import com.crowpay.views.theming.OutlineSemantic
import com.crowpay.views.theming.body
import com.crowpay.views.theming.bodyBold
import com.crowpay.views.theming.boldSubTitle
import com.crowpay.views.theming.deleteButton
import com.crowpay.views.theming.greySeparator
import com.crowpay.views.theming.notificationBar
import com.crowpay.views.theming.primaryButton
import com.crowpay.views.theming.redText
import com.crowpay.views.theming.secondaryButton
import com.crowpay.views.theming.section
import com.crowpay.views.theming.smallBody
import com.crowpay.views.theming.specCenteredText
import com.crowpay.views.theming.subTitle
import com.crowpay.views.theming.tertiaryButton
import com.crowpay.views.theming.textButton
import com.crowpay.views.theming.title
import com.lightningkite.PhoneNumber
import com.lightningkite.UUID
import com.lightningkite.kiteui.Routable
import com.lightningkite.kiteui.models.Align
import com.lightningkite.kiteui.models.Icon
import com.lightningkite.kiteui.models.ImageScaleType
import com.lightningkite.kiteui.models.KeyboardHints
import com.lightningkite.kiteui.models.div
import com.lightningkite.kiteui.models.dp
import com.lightningkite.kiteui.models.rem
import com.lightningkite.kiteui.navigation.Page
import com.lightningkite.kiteui.navigation.dialogScreenNavigator
import com.lightningkite.kiteui.navigation.mainScreenNavigator
import com.lightningkite.kiteui.navigation.render
import com.lightningkite.kiteui.reactive.Action
import com.lightningkite.kiteui.reactive.Constant
import com.lightningkite.kiteui.reactive.Draft
import com.lightningkite.kiteui.reactive.ImmediateWritable
import com.lightningkite.kiteui.reactive.LateInitProperty
import com.lightningkite.kiteui.reactive.LazyProperty
import com.lightningkite.kiteui.reactive.PersistentProperty
import com.lightningkite.kiteui.reactive.Property
import com.lightningkite.kiteui.reactive.Readable
import com.lightningkite.kiteui.reactive.Writable
import com.lightningkite.kiteui.reactive.await
import com.lightningkite.kiteui.reactive.awaitNotNull
import com.lightningkite.kiteui.reactive.bind
import com.lightningkite.kiteui.reactive.equalTo
import com.lightningkite.kiteui.reactive.invoke
import com.lightningkite.kiteui.reactive.lens
import com.lightningkite.kiteui.reactive.modify
import com.lightningkite.kiteui.reactive.reactiveSuspending
import com.lightningkite.kiteui.reactive.shared
import com.lightningkite.kiteui.reactive.withWrite
import com.lightningkite.kiteui.views.ViewModifiable
import com.lightningkite.kiteui.views.ViewWriter
import com.lightningkite.kiteui.views.atBottom
import com.lightningkite.kiteui.views.atEnd
import com.lightningkite.kiteui.views.atTopCenter
import com.lightningkite.kiteui.views.buttonTheme
import com.lightningkite.kiteui.views.centered
import com.lightningkite.kiteui.views.compact
import com.lightningkite.kiteui.views.dialog
import com.lightningkite.kiteui.views.direct.RowOrCol
import com.lightningkite.kiteui.views.direct.button
import com.lightningkite.kiteui.views.direct.checkbox
import com.lightningkite.kiteui.views.direct.col
import com.lightningkite.kiteui.views.direct.dismissBackground
import com.lightningkite.kiteui.views.direct.gravity
import com.lightningkite.kiteui.views.direct.icon
import com.lightningkite.kiteui.views.direct.image
import com.lightningkite.kiteui.views.direct.numberInput
import com.lightningkite.kiteui.views.direct.onClick
import com.lightningkite.kiteui.views.direct.onlyWhen
import com.lightningkite.kiteui.views.direct.padded
import com.lightningkite.kiteui.views.direct.phoneNumberInput
import com.lightningkite.kiteui.views.direct.radioButton
import com.lightningkite.kiteui.views.direct.row
import com.lightningkite.kiteui.views.direct.rowCollapsingToColumn
import com.lightningkite.kiteui.views.direct.scrolls
import com.lightningkite.kiteui.views.direct.select
import com.lightningkite.kiteui.views.direct.sizeConstraints
import com.lightningkite.kiteui.views.direct.space
import com.lightningkite.kiteui.views.direct.stack
import com.lightningkite.kiteui.views.direct.swapView
import com.lightningkite.kiteui.views.direct.swapping
import com.lightningkite.kiteui.views.direct.textField
import com.lightningkite.kiteui.views.direct.textInput
import com.lightningkite.kiteui.views.dynamicTheme
import com.lightningkite.kiteui.views.expanding
import com.lightningkite.kiteui.views.forEach
import com.lightningkite.kiteui.views.l2.icon
import com.lightningkite.lightningdb.Query
import com.lightningkite.lightningdb.and
import com.lightningkite.lightningdb.condition
import com.lightningkite.lightningdb.eq
import com.lightningkite.serialization.lensPath
import com.lightningkite.toEmailAddress
import com.lightningkite.toPhoneNumber
import kotlinx.coroutines.coroutineScope
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import kotlin.text.isNotBlank

abstract class ContractorNewRegistrationData : Validator() {
    val contractor = Draft {
        selectedContractor()?.let {
            currentSession()?.contractors?.get(it)?.invoke()
        } ?: Contractor(
            name = "",
            legalName = "",
            email = "",
            phoneNumber = "",
            address = Address(),
            contactFirstName = "",
            contactLastName = "",
            contactAddress = Address(),
            contactPhoneNumber = "",
            contactEmail = "",
            operationStates = setOf(),
            annualRevenue = 0,
            averageJobSize = 0,
            employeeCount = 0,
            otherBusinessData = "",
            stateEntityNumber = "",
            ein = "",
            owners = listOf()
        )
    }
    val safeContractorId = selectedContractor.value ?: UUID.random()
    val user = Draft {
        currentSession()?.self()
    }
    val submitForm = Action(
        title = "LOG IN",
        icon = Icon.login,
        action = {
            handleSave()
        }
    )
    val expanded = Property<RegisterAccountSection?>(null)

    val _trades = shared {
        notNullSession().trades.query(Query(limit = Int.MAX_VALUE))
    }
    val trades = shared {
        listOf(
            "Unselected",
            "Other"
        ) + _trades()().map { it._id }
    }

    val _licenses = shared { notNullSession().licenses.query(Query(condition { it.contractor eq contractor()._id })) }
    val _documents = shared {
        notNullSession().contractorDocuments
            .query(
                Query(condition {
                    (it.contractor eq contractor()._id) and (it.fileType eq "application/pdf")
                })
            )
    }

    // Primary User fields
    val contactFirstName = contractor.lensPath { it.contactFirstName }.validateNotBlank()
    val contactLastName = contractor.lensPath { it.contactLastName }.validateNotBlank()
    val contactEmail = contractor.lensPath { it.contactEmail }
        .validate { it.matches(SharedUtils.emailPattern) }
    val contactPhone = contractor.lensPath { it.contactPhoneNumber }
        .validate { it.matches(SharedUtils.phonePattern) }
    val primaryUserFields = listOf(
        contactFirstName,
        contactLastName,
        contactEmail,
        contactPhone
    )

    // Business Operations fields
    val businessName = contractor.lensPath { it.name }.validateNotBlank()
    val isLegalName = LazyProperty {
        contractor().name == contractor().legalName
    }
    val legalBusinessName = contractor.lensPath { it.legalName }
        .validate { it.isNotBlank() }
    val businessEmail = contractor.lensPath { it.email }
        .validate { it.matches(SharedUtils.emailPattern) }
    val businessPhone = contractor.lensPath { it.phoneNumber }
        .validate { it.matches(SharedUtils.phonePattern) }
    val businessContactAddress = contractor.lensPath { it.contactAddress }
        .validate { it.isNotBlank() }
    val businessStates = contractor.lensPath { it.operationStates }.validate { it.isNotEmpty() }
    val contractorLicenses = shared {
        _licenses()().filter { it.type == LicenseType.Contractor }
    }.withWrite { }.validate { it.isNotEmpty() }
    val businessOpsFields = listOf(
        businessName,
        businessEmail,
        businessPhone,
        businessStates,
        contractorLicenses,
        legalBusinessName,
        businessContactAddress
    )

    // Business Profile fields
    val showCustomTrade = LazyProperty {
        val currentTrade = contractor().trade
        currentTrade != null && (currentTrade.isNotEmpty() && !trades().contains(currentTrade))
    }
    val trade =
        LazyProperty {
            contractor().trade ?: "Unselected"
        }.validate {
            it.isNotBlank() && it != "Other" && it != "Unselected" && it.length > 3
        }
    val approxAnnualRevenue = contractor.lensPath { it.annualRevenue }.validate { it != null && it > 0 }
    val averageJobSize = contractor.lensPath { it.averageJobSize }
    val employeeCount = contractor.lensPath { it.employeeCount }
    val otherBusinessData = contractor.lensPath { it.otherBusinessData }
    val businessProfileFields = listOf(
        trade,
        approxAnnualRevenue,
    ) as List<ValidatedWritable<out Any>>

    // Business Verification fields
    val type =
        LazyProperty { contractor().entityType ?: "Unselected" }.validate {
            it != "Unselected"
        }
    val sameAsContact = LazyProperty {
        val contact = user()?.address ?: Address()
        if (contact.isNotBlank()) contact == contractor().address else false
    }
    val businessAddress = contractor.lensPath { it.address }
        .validate { it.isNotBlank() }
    val businessEin = contractor.lensPath { it.ein }.validateNotBlank()
    val stateBusinessEin = contractor.lensPath { it.stateEntityNumber }
    val documents = shared {
        _documents()()
    }.withWrite { }.validate { it.isNotEmpty() }
    val stateLicenses = shared {
        _licenses()().filter { it.type == LicenseType.Business }
    }
    val businessVerificationFields = listOf(
        type,
        businessEin,
        documents,
        businessAddress,
    )

    // Owners Verification fields
    val owners = contractor.lensPath { it.owners }.validate {
        it.all { it.isValid() } && it.sumOf { it.ownership } == 100 && it.any { it.document != null }
    }
    val ownersFields = listOf(
        owners
    )

    // Connect Bank Fields
    val paymentInfo = LateInitProperty<AccountInfo?>()

    suspend fun ViewWriter.retrievePaymentInfo() {
        val c = contractor.awaitNotNull()
        val result = currentSession.awaitNotNull().nonCached.contractor.getPaymentInfo(c._id)
        paymentInfo.set(result)
    }

    val editSpecifications = EditSpecifications(
        contractorId = safeContractorId,
        onSave = { spec ->
            handleSave()
        }
    )

    val registrationSections = setOf(
        RegisterAccountSection.Register,
        RegisterAccountSection.Operations,
        RegisterAccountSection.Profile,
        RegisterAccountSection.Verification,
        RegisterAccountSection.Owners,
    )

    val accountSetupSections = setOf(
        RegisterAccountSection.Bank,
        RegisterAccountSection.Alerts,
        RegisterAccountSection.Users,
        RegisterAccountSection.Specs
    )

    val entireList = registrationSections + accountSetupSections

    val helperTextSpace = AppDimensions.cornerRadii

    fun renderStatusDisplay(
        writer: ViewWriter,
        mapOfLists: Map<RegisterAccountSection, List<ValidatedWritable<out Any>>>
    ) = with(writer) {
        scrolls(vertical = false, horizontal = true) {
            showScrollBars = false
        } - stack {
            centered - sizeConstraints(height = 4.rem) - row {
                spacing = 0.rem
                mapOfLists.entries.toList().withReverseIndex().forEach { (index, pair) ->
                    atBottom - sizeConstraints(height = 2.rem, width = 6.rem) - row {
                        spacing = 0.rem
                        stack {
                            centered - sizeConstraints(
                                width = 6.05.rem.let { if (index == 0) it.div(2) else it },
                                height = 4.dp
                            ) - BackgroundSemantic(AppColors.grey.main).onNext - row {
                                dynamicTheme {
                                    val list = if (pair.key == RegisterAccountSection.Operations && isLegalName()) pair.value.dropLast(1) else pair.value
                                    if (list.isNotEmpty() &&
                                        list
                                            .filter { if (pair.key == RegisterAccountSection.Verification && sameAsContact()) it() !is Address else true }
                                            .all {
                                                it.valid()
                                            }
                                    ) {
                                        BackgroundSemantic(AppColors.secondary.main)
                                    } else {
                                        BackgroundSemantic(AppColors.grey.main)
                                    }
                                }
                                spacing = 0.rem
                            }
                        }
                    }
                }
            }
            centered - sizeConstraints(height = 4.rem) - row {
                spacing = 0.rem
                mapOfLists.entries.forEachIndexed { index, pair ->
                    sizeConstraints(height = 4.rem, width = 6.rem) - col {
                        spacing = 0.rem
                        atTopCenter - sizeConstraints(height = 2.rem) - body {
                            content = pair.key.toString()
                            align = Align.Center
                        }
                        centered - sizeConstraints(height = 2.rem) - row {
                            existsDefaultFalse {
                                val list =
                                    if (pair.key == RegisterAccountSection.Operations && isLegalName()) pair.value.dropLast(1)
                                    else pair.value

                                list.isNotEmpty() && list
                                        .filter { if (pair.key == RegisterAccountSection.Verification && sameAsContact()) it() !is Address else true }
                                        .all { it.valid() }
                            }
                            greenCheckIcon()
                        }
                        centered - sizeConstraints(height = 2.rem) - row {
                            ::exists {
                                val list =
                                    if (pair.key == RegisterAccountSection.Operations && isLegalName()) pair.value.dropLast(
                                        1
                                    ) else pair.value
                                pair.key != expanded() &&
                                        (list.isEmpty() ||
                                                list
                                                    .filter { if (pair.key == RegisterAccountSection.Verification && sameAsContact()) it() !is Address else true }
                                                    .any { !it.valid() })
                            }
                            greyStatusIcon()
                        }
                        centered - sizeConstraints(height = 2.rem) - row {
                            existsDefaultFalse {
                                val list =
                                    if (pair.key == RegisterAccountSection.Operations && isLegalName()) pair.value.dropLast(
                                        1
                                    ) else pair.value
                                (list.isEmpty() || list
                                    .filter { if (pair.key == RegisterAccountSection.Verification && sameAsContact()) it() !is Address else true }
                                    .any { !it.valid() }) &&
                                        pair.key == expanded()
                            }

                            activeStatusIcon()
                        }
                    }
                }
            }
        }
    }

    fun String.toPhoneNumberNull(): PhoneNumber {
        return try {
            this.toPhoneNumber()
        } catch (e: IllegalArgumentException) {
            PhoneNumber("+")
        }
    }

    suspend fun handleSave(request: Boolean = false, onSave: (suspend () -> Unit)? = null) {
        val session = notNullSession()
        user.modify {
            it?.copy(
                firstName = contractor().contactFirstName,
                lastName = contractor().contactLastName,
                email = contractor().contactEmail.toEmailAddress(),
                phoneNumber = contractor().contactPhoneNumber.toPhoneNumberNull(),
                address = contractor().contactAddress
            )
        }
        val u = user.publish()
        if (u != null) session.users[u._id].set(u)
        if (isLegalName()) {
            contractor.modify {
                it.copy(
                    legalName = businessName()
                )
            }
        }
        if (sameAsContact()) {
            contractor.modify {
                it.copy(
                    address = contractor().contactAddress
                )
            }
        }
        contractor.modify {
            it.copy(
                trade = trade(),
                entityType = type()
            )
        }
        val result: Contractor = contractor.pushChanges(session.contractors)
        contractor.set(result)
        if (contractor().status == ContractorStatus.Registering && request) {
            val newContractor = session.nonCached.contractor.submitForApproval(contractor()._id)
            session.contractors.localSignalUpdate({ it._id == newContractor._id }, { newContractor })
            contractor.set(newContractor)
            contractor.publish()
        }
        onSave?.invoke()
    }

    fun ViewWriter.navButtons(
        index: Int,
        showSave: Boolean = false,
        onSave: (suspend () -> Unit)? = null
    ): RowOrCol =
        row {
            secondaryButton - button {
                ::visible { index > 0 }
                specCenteredText("Previous")
                onClick {
                    handleSave()
                    expanded set (entireList.elementAtOrNull(index - 1))
                }
            }
            expanding - space()
            primaryButton - button {
                exists = showSave
                ::enabled {
                        (primaryUserFields +
                                if (isLegalName()) {
                                    businessOpsFields.dropLast(1)
                                } else {
                                    businessOpsFields
                                } +
                                businessProfileFields +
                                if (sameAsContact()) {
                                    businessVerificationFields.dropLast(1)
                                } else {
                                    businessVerificationFields
                                } + ownersFields
                                ).all { it.valid() }
                }
                specCenteredText("Submit")
                onClick {
                    handleSave(true, onSave)
                    expanded set null
                }
            }
            primaryButton - button {
                exists = !showSave
                specCenteredText("Next")
                onClick {
                    handleSave(false, onSave)
                    expanded set (entireList.elementAtOrNull(index + 1))
                }
            }
        }

    fun ViewWriter.renderPrimaryUserForm(): RowOrCol = col {
        boldSubTitle("Primary Representative")
        rowCollapsingToColumn(AppDimensions.normalCollapseWidth) {
            expanding - requiredField3("First Name") {
                validate(contactFirstName) - textInput {
                    hint = "John"
                    keyboardHints = KeyboardHints.title
                    content bind contactFirstName
                    action = submitForm
                }
            }
            expanding - requiredField3("Last Name") {
                validate(contactLastName) - textInput {
                    hint = "Smith"
                    keyboardHints = KeyboardHints.title
                    content bind contactLastName
                    action = submitForm
                }
            }
        }
        rowCollapsingToColumn(AppDimensions.normalCollapseWidth) {
            expanding - requiredField3(
                "Work Email (Login)",
                "Used to log into CrowPay and receive notifications.",
            ) {
                validate(contactEmail) - textField {
                    hint = "john@company.com"
                    keyboardHints = KeyboardHints.email
                    content bind contactEmail
                    action = submitForm
                }
            }
            expanding - requiredField3("Cell Phone", "Used for authentication and account alerts.") {
                validate(contactPhone) - phoneNumberInput {
                    hint = "(555) 123-4567"
                    content bind contactPhone
                }
            }
        }
        space()
        body("By continuing, you confirm that you are authorized to represent this business.")
        navButtons(entireList.indexOf(RegisterAccountSection.Register))
    }

    fun ViewWriter.renderBusinessOpsForm(): RowOrCol = col {
        boldSubTitle("Business Name(s)")
        requiredField3(
            "Trade Name or DBA",
            "This is the business name your clients know you by. This will be your CrowPay Account name."
        ) {
            validate(businessName) - textField {
                hint = "John's Decks"
                keyboardHints = KeyboardHints.title
                content bind businessName
                action = submitForm
            }
        }
        label2(
            "Is this also the registered legal name?",
            "If \"No\" is selected, show the field below to enter your legal name."
        ) {
            row {
                centered - radioButton {
                    checked bind isLegalName
                }
                centered - body("Yes")
                centered - radioButton {
                    checked bind isLegalName.equalTo(false)
                }
                centered - body("No")
            }
        }
        onlyWhen { !isLegalName() } -
                requiredField3(
                    "Legal Business Name",
                    "Enter your registered entity name. Must match your documents and government registration."
                ) {
                    validate(legalBusinessName) - textField {
                        hint = "John's Decks LLC"
                        keyboardHints = KeyboardHints.title
                        content bind legalBusinessName
                        action = submitForm
                    }
                }
        space()
        boldSubTitle("Business Contact")
        smallBody("Tell us more about your day-to-day business operations. This helps us verify you're eligible to use CrowPay and ensure compliance with state rules.")
        rowCollapsingToColumn(AppDimensions.normalCollapseWidth) {
            expanding - requiredField3("Business Email") {
                validate(businessEmail) - textField {
                    hint = "info@company.com"
                    keyboardHints = KeyboardHints.email
                    content bind businessEmail
                    action = submitForm
                }
            }
            expanding - requiredField3("Business Phone", "Primary business phone.") {
                validate(businessPhone) - phoneNumberInput {
                    hint = "(555) 123-4567"
                    content bind businessPhone
                }
            }
        }
        requiredLabel2("Business Address") {
            smallBody("This is where you operate from day-to-day")
            addressForm(
                businessContactAddress,
                this@ContractorNewRegistrationData
            )
        }
        notificationBar(AppColors.blue) - stack {
            col {
                spacing = AppDimensions.cornerRadii
                body("You may not publish projects in unapproved states.")
            }
        }
        requiredField3(
            "States Where You Operate",
            "We'll flag any states where escrow isn't yet supported."
        ) {
            val states = shared { State.entries.map { it } }
            validate(businessStates) - multiselect(
                query = { query -> states().filter { it.name.contains(query, true) } },
                pull = { id -> states().first { it == id } },
                getId = { it },
                toString = { it.name },
                items = businessStates,
                hintText = "Select one or multiple states"
            )
        }
        requiredField3(
            "Upload Contractor Licenses",
            "Attach trade or professional licenses relevant to your work."
        ) {
            validate(contractorLicenses) - renderLicenses(contractorLicenses, LicenseType.Contractor)
        }
        space()
        navButtons(entireList.indexOf(RegisterAccountSection.Operations))
    }

    fun ViewWriter.renderBusinessProfileForm(): RowOrCol = col {
        boldSubTitle("Business Snapshot")
        smallBody("This helps us better understand your business scale and the types of projects you typically handle.")
        rowCollapsingToColumn(AppDimensions.normalCollapseWidth) {
            expanding - requiredField3(
                "Trade / Industry",
                "Pick what best describes your business."
            ) {
                validate(trade) - select {
                    bind(trade, trades) { it }
                }
                reactiveSuspending {
                    if (trade() == "Other") {
                        trade.set("")
                        showCustomTrade.set(true)
                    } else if (
                        trades().any { it == trade() }
                    ) {
                        showCustomTrade.set(false)
                    }
                }
            }
            expanding - onlyWhen { showCustomTrade() } - requiredLabel2("Custom Trade") {
                validate(trade) - textInput {
                    hint = "Enter Trade"
                    content bind trade
                }
            }
        }
        requiredField3(
            "Approx. Annual Revenue",
            "Help us tailor features to your business scale."
        ) {
            validate(approxAnnualRevenue) - numberInput {
                hint = "$500,000"
                keyboardHints = KeyboardHints.integer
                range = 0.0..Double.MAX_VALUE
                content bind approxAnnualRevenue.zeroToNull()
                action = submitForm
            }
        }
        rowCollapsingToColumn(AppDimensions.normalCollapseWidth) {
            expanding - field3("Average Project Size", "Used to estimate transaction volume.") {
                numberInput {
                    hint = "$15,000"
                    keyboardHints = KeyboardHints.integer
                    range = 0.0..Double.MAX_VALUE
                    content bind averageJobSize.zeroToNull()
                    action = submitForm
                }
            }
            expanding - field3("Number of Employees", "Include full and part-time employees.") {
                numberInput {
                    hint = "10"
                    keyboardHints = KeyboardHints.integer
                    range = 0.0..Double.MAX_VALUE
                    content bind employeeCount.zeroToNull()
                    action = submitForm
                }
            }
        }
        field3(
            "Additional Details (optional)",
            "Any industry specialities or info you want to share.",
        ) {
            textInput {
                hint = ""
                keyboardHints = KeyboardHints.paragraph
                content bind otherBusinessData.nullableToBlank()
                action = submitForm
            }
        }
        space()
        navButtons(entireList.indexOf(RegisterAccountSection.Profile))
    }

    fun ViewWriter.renderBusinessVerificationForm(): RowOrCol = col {
        boldSubTitle("Business Identity")

        smallBody("We know paperwork can be a pain — but it’s required to verify your business and protect your funds. Hang in there, you’re almost done!")

        subTitle { ::content { if (isLegalName()) businessName() else legalBusinessName() } }

        rowCollapsingToColumn(AppDimensions.normalCollapseWidth) {
            expanding - requiredField3(
                "Business Entity Type",
                "Select your registered business structure."
            ) {
                val types = shared {
                    listOf(
                        "Unselected"
                    ) + notNullSession().entityTypes.query(Query(limit = Int.MAX_VALUE))().map { it._id }
                }
                validate(type) - select {
                    bind(type, types) { it }
                }
            }
        }
        label2("Same as Contact Address?") {
            row {
                centered - checkbox { checked bind sameAsContact }
                centered - body("Same As Contact Address")
            }
        }
        onlyWhen { !sameAsContact() } - requiredLabel2(
            "Registered Entity Address"
        ) {
            smallBody("Official business address per government registration.")
            addressForm(businessAddress, this@ContractorNewRegistrationData)
        }
        requiredField3("Federal EIN (Tax ID Number)") {
            validate(businessEin) - textField {
                hint = "12-3456789"
                keyboardHints = KeyboardHints.id
                content bind businessEin
                action = submitForm
            }
        }
        requiredField3(
            "Upload Articles of Inc / Org",
            "Required for verification. Accepted: PDF, JPG, PNG"
        ) {
            validate(documents) - renderContractorDocuments(
                documents,
                listOf("application/pdf")
            )
        }
        space()
        boldSubTitle("Registration Numbers & Licenses")
        field3("State License Number", "Enter your state's official business license # (if applicable).") {
            textField {
                hint = ""
                keyboardHints = KeyboardHints.id
                content bind stateBusinessEin
                action = submitForm
            }
        }
        field3(
            "Upload Municipal Licenses",
            "Upload city/county licenses if applicable."
        ) {
            renderLicenses(stateLicenses, LicenseType.Business)
        }
//        label2(
//            "Automatic Business Verification Notice"
//        ) { body("We use PayQuicker to verify business status and expidite approvals.") }
        space()
        navButtons(entireList.indexOf(RegisterAccountSection.Verification))
    }

    fun ViewWriter.renderOwnerInformationForm(): RowOrCol = col {
        boldSubTitle("Owner Personal Details")
        smallBody("For compliance purposes, we need to gather a few details about the business owners. You are required to list any owner who owns at least 25%.")
        atEnd - tertiaryButton - button {
            spacing = 0.3.rem
            specCenteredText("+ Add Owner")
            onClick {
                dialogScreenNavigator.navigate(
                    CreateOrEditOwner(
                        owner = null
                    ) { owner ->
                        contractor.modify {
                            it.copy(
                                owners = it.owners + owner
                            )
                        }
                        handleSave()
                    })
            }
        }
        col {
            spacing = 0.rem
            forEach(owners) { owner ->
                val expanded = Property(false)
                row {
                    spacing = 0.5.rem
                    sizeConstraints(height = 3.5.rem) - expanding - leftExpandButton(expanded) {
                        row {
                            spacing = 8.dp
                            centered - subTitle {
                                ::content { "${owner.title.takeUnless { it.isBlank() } ?: "No Title"}: ${owner.legalFirstName} ${owner.legalLastName}" }
                            }
                            centered - smallBody("(${owner.ownership}%)")
                        }
                    }
                    row {
                        centered - buttonTheme - button {
                            spacing = 0.25.rem
                            onClick {
                                dialogScreenNavigator.navigate(CreateOrEditOwner(owner) { updatedOwner ->
                                    contractor.modify {
                                        it.copy(
                                            owners = it.owners - owner + updatedOwner
                                        )
                                    }
                                    handleSave()
                                })
                            }
                            centered - icon(Icon.edit.resize(1.5.rem), "Edit Change Order")
                        }
                        compact - centered - deleteButton - button {
                            centered - icon(Icon.trash.resize(1.5.rem), "Delete")
                            onClick {
                                dialogScreenNavigator.navigate(
                                    GenericConfirmationDialog(
                                        header = "Delete Owner?",
                                        message = "You are about to remove this owner form the list. Deleted owners cannot be recovered. Delete this Owner?",
                                        confirmationText = "Delete Owner",
                                        confirmationTheme = DangerButtonSemantic,
                                        onSubmit = { confirmed ->
                                            if (confirmed) {
                                                contractor.modify {
                                                    it.copy(
                                                        owners = it.owners - owner
                                                    )
                                                }
                                                handleSave()
                                            }
                                        }
                                    )
                                )
                            }
                        }
                    }
                }

                onlyWhen { expanded() } - col {
                    space()
                    requiredField3("Legal First Name", "Enter the owner's legal first name.") {
                        validate { owner.legalFirstName.isNotBlank() } - body {
                            ::content { owner.legalFirstName }
                        }
                    }
                    requiredField3("Legal Last Name", "Enter the owner's legal last name.") {
                        validate { owner.legalLastName.isNotBlank() } - body {
                            ::content { owner.legalLastName }
                        }
                    }
                    requiredField3("Home Address", "Residential address of the owner.") {
                        validate { owner.address.isNotBlank() } - body {
                            ::content {
                                val address = owner.address
                                "${address.line1}, ${address.city}, ${address.state}, ${address.zipcode}"
                            }
                        }
                    }
                    space()
                    boldSubTitle("Identity & Verification")
                    requiredField3("Owner Title", "Job title or role in the business.") {
                        validate { owner.title.isNotBlank() } - body {
                            ::content {
                                owner.title
                            }
                        }
                    }
                    requiredField3("Date of Birth", "Used for identity verification.") {
                        validate { owner.birthDate != null } - body {
                            ::content {
                                owner.birthDate.toString()
                            }
                        }
                    }
                    requiredField3(
                        "Social Security Number",
                        "Encrypted and stored securely. Required for U.S. individuals."
                    ) {
                        validate { owner.ssnDisplay.isNotBlank() } - body {
                            ::content {
                                owner.ssnDisplay
                            }
                        }
                    }
                    requiredField3(
                        "Percentage of Ownership",
                        "Enter ownership as a whole number percentage (e.g. 25)."
                    ) {
                        validate { owner.ownership > 0 } - body {
                            ::content {
                                "${owner.ownership}%"
                            }
                        }
                    }
                    label2(
                        "Upload Government ID (Primary Admin Only)",
                        "Only required for the individual setting up the account. Accept: PDF, JPG, PNG."
                    ) {
                        val displayImage = LazyProperty {
                            owner.document?.let { FilePreview.RemoteFile(it.location) }
                                ?: FilePreview.Empty
                        }
                        sizeConstraints(width = 6.rem, height = 6.rem) - image {
                            scaleType = ImageScaleType.Fit
                            description = "ID"
                            ::source {
                                displayImage().getImage()
                            }
                        }
                    }
                    space()
                }
                greySeparator()
            }
        }
        space()
        navButtons(entireList.indexOf(RegisterAccountSection.Owners), true)
    }

    fun ViewWriter.renderConnectBankForm(): RowOrCol = col {
        boldSubTitle("Bank Setup")
        label2(
            "Connect Bank Account",
            "Link your account for receiving and sending payments."
        ) {

            row {
                section - padded - expanding - col {
                    subTitle("CrowPay Card")
                    body("Coming Soon")
                }
            }

            row {
                section - padded - expanding - col {
                    subTitle("Same Day")
                    body("Coming Soon")
                }
            }

            row {
                section - padded - expanding - col {
                    subTitle("2-3 Days")

                    col {
                        ::exists{ paymentInfo() != null }
                        row {
                            bodyBold {
                                ::content{ "${paymentInfo()?.bankName ?: ""}: " }
                            }
                            body {
                                ::content{ paymentInfo()?.accountName ?: "" }
                            }
                        }

                        gravity(Align.Start, Align.Center) - buttonTheme - button {
                            redText - body("Remove Bank Account")
                            onClick {
                                dialogScreenNavigator.navigate(
                                    GenericConfirmationDialog(
                                        header = "Clear Payment Info?",
                                        message = "This will clear out your submitted payment info. Without it you will not be able to cash out your money until you enter a new one.",
                                        confirmationText = "Clear Payment Info",
                                        onSubmit = {
                                            if (it) {
                                                notNullSession().nonCached.contractor
                                                    .clearPaymentInfo(notNullContractor.await())
                                                delay(500)
                                                retrievePaymentInfo()
                                            }
                                        }
                                    )
                                )
                            }
                        }
                    }
                    col {
                        val addingBank = Property(false)
                        exists = false
                        ::exists{ paymentInfo() == null }

                        gravity(Align.Start, Align.Center) - tertiaryButton - button {
                            ::exists{ !addingBank() }
                            body("+ Connect Account")
                            onClick {
                                addingBank.value = true
                            }
                        }

                        col {
                            ::exists{ addingBank() }

                            validating {

                                val bankName = Property("")
                                val accountName = Property("")
                                val routingNumber = Property("")
                                val accountNumber = Property("")
                                launch { retrievePaymentInfo() }

                                requiredField("Bank Name") {
                                    val value = bankName.validate { it.isNotBlank() }
                                    textInput {
                                        hint = "Bank Name"
                                        keyboardHints = KeyboardHints.title
                                        content bind value
                                    }
                                }

                                requiredField("Account Name") {
                                    val value = accountName.validate { it.isNotBlank() }
                                    textInput {
                                        hint = "Account Name"
                                        keyboardHints = KeyboardHints.title
                                        content bind value
                                    }
                                }

                                requiredField("Routing Number") {
                                    val value =
                                        routingNumber.validate { SharedUtils.isRoutingNumberValid(it) }
                                    textInput {
                                        hint = "Routing Number"
                                        keyboardHints = KeyboardHints.integer
                                        content bind value
                                    }
                                }

                                requiredField("Account Number") {
                                    val value = accountNumber.validate { it.isNotBlank() }
                                    textInput {
                                        hint = "Account Number"
                                        content bind value
                                    }
                                }

                                row {
                                    tertiaryButton - button {
                                        ::enabled{ allValid() }
                                        specCenteredText("Save Bank Account")
                                        onClick {
                                            val c = notNullContractor.await()

                                            notNullSession().nonCached.contractor.setupPaymentInfo(
                                                id = c,
                                                input = PaymentSetupRequest(
                                                    bankName = bankName.value,
                                                    routingNumber = routingNumber.value.toInt(),
                                                    accountNumber = accountNumber.value,
                                                    accountName = accountName.value
                                                )
                                            )
                                            delay(500)
                                            retrievePaymentInfo()

                                            addingBank.value = false
                                            bankName.value = ""
                                            accountName.value = ""
                                            routingNumber.value = ""
                                            accountNumber.value = ""
                                        }
                                    }

                                    textButton - button {
                                        specCenteredText("Cancel")
                                        onClick {
                                            addingBank.value = false
                                            bankName.value = ""
                                            accountName.value = ""
                                            routingNumber.value = ""
                                            accountNumber.value = ""
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        space()
        navButtons(entireList.indexOf(RegisterAccountSection.Bank))
    }

    fun ViewWriter.renderAlertsForm(viewed: ImmediateWritable<Set<UUID>>): RowOrCol = col {
        val settings = NotificationSubscriptionSettings(ProjectLens.Contractor)
        label2("Notification Preferences") {
            smallBody("Choose how you want to receive CrowPay updates (email, SMS, both)")
            settings.renderSettings(this)
        }
        space()
        navButtons(entireList.indexOf(RegisterAccountSection.Alerts)) {
            coroutineScope {
                settings.save.startAction(this)
                viewed.value += safeContractorId
            }
        }
    }

    fun ViewWriter.renderUserAdminForm(viewed: ImmediateWritable<Set<UUID>>): RowOrCol = col {
        val users = ManageContractorUsers()
        label2("Add Additional Users/Admins") {
            smallBody("Invite other team members to help manage your account")
            users.renderTo(this)
        }
        space()
        navButtons(entireList.indexOf(RegisterAccountSection.Users)) {
            coroutineScope {
                users.save(this@col).startAction(this)
                viewed.value += safeContractorId
            }
        }
    }

    fun ViewWriter.renderAccountSpecificationsForm(viewed: ImmediateWritable<Set<UUID>>): RowOrCol = col {
        label2("Additional Config Options") {
            smallBody("Advanced options available in Settings after setup.")
            editSpecifications.render(this)
        }
        space()
        navButtons(entireList.indexOf(RegisterAccountSection.Specs), showSave = true) {
            viewed.value += safeContractorId
            dialogScreenNavigator navigateTo object : Page {
                override fun ViewWriter.render2(): ViewModifiable = dismissBackground {
                    fun ViewWriter.exit() {
                        mainScreenNavigator.reset(ContractorDashboard())
                        dialogScreenNavigator.dismiss()
                    }

                    onClick { exit() }

                    spacing = AppDimensions.fullIndent
                    centered - sizeConstraints(width = 40.rem) - dialog - stack {
                        spacing = AppDimensions.fullIndent
                        col {
                            spacing = AppDimensions.majorColumnSpacing

                            title("Registration Completed!")

                            col {
                                notificationBar(AppColors.blue) - body(
                                    """
                                        You have successfully submitted your registration information to CrowPay. We will review your information notify you when it gets approved. 
                                        Until then, feel free to explore the app and familiarize yourself its features.
                                    """.trimIndent()
                                )

                                notificationBar(AppColors.yellow) - body(
                                    """
                                        Note that until your information is approved by an Admin you will have limited access to certain parts of the app, such as creating projects.
                                    """.trimIndent()
                                )
                            }

                            row {
                                primaryButton - button {
                                    specCenteredText("Home")
                                    onClick("Leave and go to dashboard") { exit() }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

@Routable("contractor/register")
class ContractorNewRegistration : Page, ContractorNewRegistrationData() {
    override val title: Readable<String> = Constant("Register")

    override fun ViewWriter.render2() = scrolls - col {
        launch { retrievePaymentInfo() }
        sizeConstraints(width = AppDimensions.pageWidth) - col {
            swapView {
                spacing = 0.rem
                swapping(
                    current = {
                        expanded() in accountSetupSections
                    },
                    views = {
                        if (it) {
                            val map = accountSetupSections.zip(
                                listOf(
                                    shared { paymentInfo() != null },
                                    alertsViewed,
                                    userSettingsViewed,
                                    specificationsViewed
                                ).map { readable ->
                                    listOf(
                                        object : ValidatedWritable<Unit>, Writable<Unit> by Property(Unit) {
                                            override suspend fun refresh() {}
                                            override val validator: Validator get() = this@ContractorNewRegistration
                                            override val valid: ValidCondition = readable
                                        }
                                    )
                                }
                            ).toMap()
                            renderStatusDisplay(
                                this,
                                map
                            )
                        } else {
                            val map = registrationSections.zip(
                                listOf(
                                    primaryUserFields,
                                    businessOpsFields,
                                    businessProfileFields,
                                    businessVerificationFields,
                                    ownersFields
                                )
                            ).toMap()
                            renderStatusDisplay(
                                this,
                                map
                            )
                        }
                    }
                )
            }

            rowCollapsingToColumn(AppDimensions.normalCollapseWidth) {
                centered - title("Register Account")
                centered - subTitle("(Must be submitted within 7 days)")
            }

            entireList.forEachIndexed { index, regSection ->
                if (accountSetupSections.contains(regSection)) return@forEachIndexed

                val thisExpand = shared {
                    regSection == expanded()
                }.withWrite {
                    if (it) expanded set regSection
                    else expanded set null
                }
                col {
                    row {
                        spacing = helperTextSpace
                        sizeConstraints(width = 1.75.rem, height = 1.75.rem) - row {
                            spacing = 0.rem
                            val isFinished = shared {
                                when (regSection) {
                                    RegisterAccountSection.Register -> primaryUserFields.all { it.valid() }
                                    RegisterAccountSection.Operations -> if (isLegalName()) businessOpsFields.dropLast(1)
                                        .all { it.valid() } else businessOpsFields.all { it.valid() }

                                    RegisterAccountSection.Profile -> businessProfileFields.all { it.valid() }
                                    RegisterAccountSection.Verification -> if (sameAsContact()) businessVerificationFields.dropLast(
                                        1
                                    )
                                        .all { it.valid() } else businessVerificationFields.all { it.valid() }

                                    RegisterAccountSection.Owners -> owners().all { it.isValid() } && owners().any { it.document != null } && owners().sumOf { it.ownership } == 100
                                    else -> false
                                }
                            }
                            row {
                                spacing = 0.rem
                                existsDefaultFalse { !isFinished() && expanded() == regSection }
                                activeStatusIcon()
                            }
                            row {
                                spacing = 0.rem
                                ::exists { !isFinished() && expanded() != regSection }
                                greyStatusIcon()
                            }
                            row {
                                spacing = 0.rem
                                existsDefaultFalse { isFinished() }
                                greenCheckIcon()
                            }
                        }
                        section - expanding - leftExpandButton(thisExpand) {
                            row {
                                spacing = 0.rem
                                body("STEP ${index + 1} ")
                                bodyBold(regSection.displayName)
                            }
                        }
                    }
                    onlyWhen(false) { thisExpand() } - indentIfWideCol(Indent.Section) {
                        when (regSection) {
                            RegisterAccountSection.Register -> renderPrimaryUserForm()
                            RegisterAccountSection.Operations -> renderBusinessOpsForm()
                            RegisterAccountSection.Profile -> renderBusinessProfileForm()
                            RegisterAccountSection.Verification -> renderBusinessVerificationForm()
                            RegisterAccountSection.Owners -> renderOwnerInformationForm()
                            else -> null
                        }
                    }
                }
            }

            space()

            row {
                centered - title("Account Setup")
            }

            entireList.forEachIndexed { index, regSection ->
                if (registrationSections.contains(regSection)) return@forEachIndexed
                val thisExpand = shared {
                    regSection == expanded()
                }.withWrite {
                    if (it) expanded set regSection
                    else expanded set null
                }
                col {
                    row {
                        spacing = helperTextSpace
                        val isFinished = shared {
                            when (regSection) {
                                RegisterAccountSection.Bank -> paymentInfo() != null
                                RegisterAccountSection.Alerts -> alertsViewed()
                                RegisterAccountSection.Users -> userSettingsViewed()
                                RegisterAccountSection.Specs -> specificationsViewed()
                                else -> false
                            }
                        }
                        row {
                            spacing = 0.rem
                            ::exists { !isFinished() && expanded() == regSection }
                            activeStatusIcon()
                        }
                        row {
                            spacing = 0.rem
                            ::exists { !isFinished() && expanded() != regSection }
                            greyStatusIcon()
                        }
                        row {
                            spacing = 0.rem
                            ::exists { isFinished() }
                            greenCheckIcon()
                        }
                        section - expanding - leftExpandButton(thisExpand) {
                            row {
                                spacing = 0.rem
                                body("STEP ${index + 1} ")
                                bodyBold(regSection.displayName)
                            }
                        }
                    }
                    onlyWhen(false) { thisExpand() } - indentIfWideCol(Indent.Section) {
                        when (regSection) {
                            RegisterAccountSection.Bank -> renderConnectBankForm()
                            RegisterAccountSection.Alerts -> renderAlertsForm(alertsViewedBy)
                            RegisterAccountSection.Users -> renderUserAdminForm(userSettingsViewedBy)
                            RegisterAccountSection.Specs -> renderAccountSpecificationsForm(specificationsViewedBy)
                            else -> null
                        }
                    }
                }
            }
        }
    }

    private val alertsViewedBy = PersistentProperty("alert-settings-viewed", emptySet<UUID>())
    private val alertsViewed = alertsViewedBy.lens { safeContractorId in it }

    private val userSettingsViewedBy = PersistentProperty("user-settings-viewed", emptySet<UUID>())
    private val userSettingsViewed = userSettingsViewedBy.lens { safeContractorId in it }

    private val specificationsViewedBy = PersistentProperty("spec-settings-viewed", emptySet<UUID>())
    private val specificationsViewed = specificationsViewedBy.lens { safeContractorId in it }
}

fun ViewWriter.greenCheckIcon() = sizeConstraints(width = 1.75.rem, height = 1.75.rem) - centered - stack {
    spacing = 0.rem
    themeChoice += OutlineSemantic(AppColors.secondary.main, 2.dp) + MaxRadiiSemantic
    centered - icon {
        source = Icon.done
        themeChoice += ForegroundSemantic(AppColors.secondary.main)
    }
}

fun ViewWriter.activeStatusIcon() = sizeConstraints(width = 1.75.rem, height = 1.75.rem) - centered - stack {
    spacing = 0.rem
    themeChoice += OutlineSemantic(AppColors.primary.main, 2.dp) + MaxRadiiSemantic
    centered - sizeConstraints(width = 0.5.rem, height = 0.5.rem) - row {
        spacing = 0.rem
        themeChoice += BackgroundSemantic(AppColors.primary.main) + MaxRadiiSemantic
    }
}

fun ViewWriter.greyStatusIcon() = sizeConstraints(width = 1.75.rem, height = 1.75.rem) - centered - stack {
    spacing = 0.rem
    themeChoice += OutlineSemantic(AppColors.grey.main, 2.dp) + MaxRadiiSemantic
    centered - sizeConstraints(width = 0.5.rem, height = 0.5.rem) - row {
        spacing = 0.rem
        themeChoice += OutlineSemantic(AppColors.grey.main, 2.dp) + MaxRadiiSemantic
    }
}